import { Typography, styled } from '@mui/material';

const NumLabel = styled(Typography)`
  background-color: ${({ isQueue }) => (isQueue ? '#ff9800' : 'white')};
  padding: 4px;
  border-radius: 4px;

  color: ${({ isQueue }) => (isQueue ? 'white' : '#47607c')};
  font-size: 12px;
  text-align: center;
`;

export default NumLabel;
